import router from '@/router'

window.gtag('config', 'G-RGPSBFKQJG', {
  'send_page_view': process.env.NODE_ENV === 'production'
})

router.beforeEach((to, from, next) => {
  window.gtag('config', 'G-RGPSBFKQJG', { 'page_path': to.path })
  next()
})
